module.exports = __webpack_public_path__ + "static/media/IMG_0062.cb44fae2.jpg";